import React, { useState, useEffect } from "react";
import api from "../../api/api";
import "../../css/Addemployee.css";

const Purchase = () => {
  const [quantity, setQuantity] = useState(0);
  const [price, setPrice] = useState("");
  const [unit, setUnit] = useState("");
  const [expectedDate, setExpectedDate] = useState("");
  const [suppliers, setSuppliers] = useState([]);
  const [selectedSupplier, setSelectedSupplier] = useState("");
  const [items, setItems] = useState([]);
  const [selectedItem, setSelectedItem] = useState("");
  const [note, setNote] = useState(""); // ✅ Added note state

  const [units, setUnits] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleIncrement = () => {
    setQuantity((prev) => prev + 1);
  };

  const handleDecrement = () => {
    if (quantity > 0) setQuantity((prev) => prev - 1);
  };

  // Fetch suppliers
  useEffect(() => {
    const fetchSuppliers = async () => {
      try {
        const response = await api.get("/get/getProvider");
        if (response.data && response.data.data) {
          setSuppliers(response.data.data); // ✅ Populate supplier list
        }
      } catch (error) {
        console.error("Failed to fetch suppliers", error);
      }
    };

    fetchSuppliers();
  }, []);

  // Fetch items
  useEffect(() => {
    const fetchItems = async () => {
      if (!selectedSupplier) {
        setItems([]);
        return;
      }

      try {
        const response = await api.post("/get/raw/material", {
          supplier_id: selectedSupplier,
        });
        if (response.data && response.data.data) {
          setItems(response.data.data);
        }
      } catch (error) {
        console.error("Failed to fetch items", error);
      }
    };

    fetchItems();
  }, [selectedSupplier]);

  // Fetch units
  useEffect(() => {
    const fetchUnits = async () => {
      try {
        const response = await api.get("/get/weight/measure");
        if (response.data && response.data.data) {
          setUnits(response.data.data);
        }
      } catch (error) {
        console.error("Failed to fetch units", error);
      }
    };

    fetchUnits();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true); // ✅ Show loading
  
    // ✅ Step-by-step validation
    if (!selectedSupplier) {
      alert("Please select a supplier.");
      setIsSubmitting(false);
      return;
    }
  
    if (!selectedItem) {
      alert("Please select an item.");
      setIsSubmitting(false);
      return;
    }
  
    if (!quantity || quantity <= 0) {
      alert("Please enter a valid quantity.");
      setIsSubmitting(false);
      return;
    }
  
    if (!price || isNaN(price)) {
      alert("Please enter a valid price.");
      setIsSubmitting(false);
      return;
    }
  
    if (!unit) {
      alert("Please enter a unit of measure.");
      setIsSubmitting(false);
      return;
    }
  
    if (!expectedDate) {
      alert("Please enter an expected delivery date.");
      setIsSubmitting(false);
      return;
    }
  
    const payload = {
      provider_id: selectedSupplier,
      item_id: selectedItem,
      quantity,
      price,
      measure: unit,
      expected_deliver: expectedDate,
      note: note, // ✅ Added note to payload
    };
  
    try {
      const response = await api.post("/store-purchase", payload);
  
      if (response.data.success) {
        alert("Purchase Added Successfully");
  
        // ✅ Reset all fields
        setSelectedSupplier("");
        setSelectedItem("");
        setQuantity(0);
        setPrice("");
        setUnit("");
        setExpectedDate("");
        setNote(""); // ✅ Reset note
      }
    } catch (error) {
      console.error("Failed to submit purchase", error);
      alert("Submission failed. Please try again.");
    } finally {
      setIsSubmitting(false); // ✅ Hide loading
    }
  };
  
  return (
    <section className="employee-section add-employee-001">
      <div className="inner-content">
        <div className="filter-wrapper">
          <h2>Official Purchase Requisition</h2>
        </div>
        <div className="add-wrapper">
          <div className="content-wrapper">
            <h2>Add Purchase Details </h2>
            <form onSubmit={handleSubmit}>
              <div className="row-wrapper">
                <div className="main-wrapper custom-select">
                  <label>Supplier</label>
                  <select
                    value={selectedSupplier}
                    onChange={(e) => setSelectedSupplier(e.target.value)}
                  >
                    <option value="">Choose supplier</option>
                    {suppliers.map((supplier) => (
                      <option key={supplier.id} value={supplier.id}>
                        {supplier.name}
                      </option>
                    ))}
                  </select>
                  <i className="fas fa-chevron-down select-icon"></i>
                </div>

                <div className="main-wrapper custom-select">
                  <label>Item</label>
                  <select
                    value={selectedItem}
                    onChange={(e) => setSelectedItem(e.target.value)}
                  >
                    <option value="">Choose Item</option>
                    {items.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                  <i className="fas fa-chevron-down select-icon"></i>
                </div>
              </div>

              <div className="row-wrapper">
                <div className="main-wrapper">
                  <label>Quantity</label>
                  <div className="quantity-control-001">
                    <button type="button" onClick={handleDecrement}>
                      -
                    </button>
                    <input type="text" value={quantity} readOnly />
                    <button type="button" onClick={handleIncrement}>
                      +
                    </button>
                  </div>
                </div>

                <div className="main-wrapper">
                  <label>Price</label>
                  <input
                    type="number"
                    placeholder="Enter price"
                    value={price}
                    onChange={(e) => setPrice(e.target.value)}
                  />
                </div>
              </div>

              <div className="row-wrapper">
                <div className="main-wrapper custom-select">
                  <label>Unit</label>
                  <select
                    value={unit}
                    onChange={(e) => setUnit(e.target.value)}
                  >
                    <option value="">Select Unit</option>
                    {units.map((u) => (
                      <option key={u.id} value={u.unit}>
                        {u.unit}
                      </option>
                    ))}
                  </select>

                  <i className="fas fa-chevron-down select-icon"></i>
                </div>

                <div className="main-wrapper">
                  <label>Expected Delivery</label>
                  <input
                    type="date"
                    value={expectedDate}
                    onChange={(e) => setExpectedDate(e.target.value)}
                  />
                </div>
              </div>

              <div className="row-wrapper">
                <div className="main-wrapper">
                  <label>Note</label>
                  <textarea
                    placeholder="Enter note (optional)"
                    value={note}
                    onChange={(e) => setNote(e.target.value)}
                  ></textarea>
                </div>
              </div>

              <div className="btn-sub">
                <button type="submit" disabled={isSubmitting}>
                  {isSubmitting ? "Submitting..." : "Submit"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Purchase;
